module.exports = __webpack_public_path__ + "img/google_play.148ec2fb.png";